<template>
  <div class="privacy-policy">
		<section>
			<h2>隐私政策</h2>
			<p>本隐私政策适用于您对上海高绩数据科技有限公司（以下简称“我们”）提供的信息技术服务产品的访问和使用留存的信息。欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。</p>
		</section>
		<section>
			<h3>引言</h3>
			<p>我们尽量以更清晰、更容易被您理解的方式展现本隐私政策，从而希望能够真实地传达我们希望向您传达的信息，并希望您在向我们提供某些信息（其中很可能包括您的个人信息）以及允许我们处理并分享某些信息之前，能够清晰地了解这些信息收集的目的、可能的用途以及其他方面的内容。为了便于您阅读及理解，我们将专门术语进行了定义，请参见本隐私政策“附录1：定义”来了解这些定义的具体内容。</p>

			<p>本隐私政策适用于高绩平台（范围详见附录1：定义）所有产品和服务。如某款高绩产品有单独的隐私政策，则该产品的隐私政策将优先适用。该产品隐私政策未涵盖的内容，以本隐私政策内容为准。</p>
			<p>本隐私政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。若您使用高绩平台的服务，即表示您认同我们在本政策中所述内容。在将您的信息用于本隐私权政策未涵盖的用途时，我们会事先征求您的同意。</p>
			<p>此外，我们在产品设计的过程中及最终的呈现和用户体验环节，将尽可能地为您控制个人信息、保护个人隐私提供更为便捷的方式。</p>
			<div>
				<p>本隐私政策将帮助您了解以下内容：</p>
				<ul>
					<li><span>1.</span>我们如何收集和使用您的个人信息 </li>
					<li><span>2.</span>我们如何使用 Cookie 和同类技术  </li>
					<li><span>3.</span>我们如何共享、转让、公开披露您的个人信息</li>
					<li><span>4.</span>我们如何保存及保护您的个人信息</li>
					<li><span>5.</span>您的权利</li>
					<li><span>6.</span>我们如何处理未成年人的个人信息</li>
					<li><span>7.</span>您的个人信息如何跨境转移</li>
					<li><span>8.</span>隐私政策的修订</li>
					<li><span>9.</span>如何联系我们</li>
				</ul>
			</div>
			<p>我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。感谢您对高绩平台的使用和信任！我们致力于维持您对我们的信任，恪守适用法律和我们对您的承诺，尽全力保证您的个人信息安全和合理使用。同时，我们郑重承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
		</section>
		<section>
			<h3>一、	我们如何收集和使用您的个人信息</h3>
			<p>高绩平台仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息：</p>
			<ul>
				<li>
					<h5>1）	帮助您成为我们的注册用户</h5>
					<p>您注册高绩帐号时须至少向我们提供帐号名称、手机号码及或电子邮箱，并创建密码。</p>
					<p>您提供的上述信息，将在您使用高绩平台产品和服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息或对您的个人信息进行匿名化处理，法律法规另有规定的除外。</p>
				</li>
				<li>
					<h5>2）	向您提供产品和服务</h5>
					<h5>1. 您向我们提供的信息</h5>
					<p>您使用我们的特定产品和服务时（如申请试用学科发展水平数据监测平台），为满足向您提供产品和服务之目的，除注册时提供的信息外，您可能还需要进一步向我们提供与上述产品和服务的功能相关的信息（例如您的真实姓名、性别、常用地址等），为了验证您提供信息的准确性和完整性，或保障您的帐号安全，我们会与合法留存您的信息的国家机关、金融机构、企事业单位进行核对。如果您不使用特定产品和服务，则无需提供相关信息。</p>
					<p>当您使用刷脸登录验证功能时，我们会收集您的面部信息。您应按照页面的提示完成相应动作，高绩系统判断您的动作符合要求后，即可完成脸部拍摄。您同意仅使用您本人的面部信息为您本人所持有的高绩账户使用刷脸登录、验证服务。为了提高验证的准确性，您同意高绩可在必要时将您向高绩提供的面部信息与法律法规允许的机构或政府机关授权的机构所保存的您的面部信息进行比对核验。如果您不使用刷脸登录功能，则无需提供相关信息。</p>
					<p>我们还可能会记录您在使用我们的产品和/或服务时提供、形成或留存的信息。例如您在使用高绩搜索时输入的搜索关键词信息和点击的链接，您参与其他产品运营活动时提交的信息。您有权选择不提供前述信息，但这将导致您可能无法使用特定服务或功能，或者无法达到相关服务拟达到的效果。</p>
					<h5>2．我们在您使用服务过程中收集的信息</h5>
					<p>我们可能会收集关于您使用产品和/或服务（包括使用方式）过程中的信息，此类信息包括：</p>
					<ol>
						<li>
							设备信息：为了提供向您更好的产品和/或服务及保障您的账号安全，经您授权我们会收集设备属性信息（例如您的硬件型号、操作系统版本、设备名称、设备配置、唯一设备标识符（国际移动设备身份码IMEI、网络设备硬件地址MAC、广告标识符IDFA）），设备连接信息（浏览器的类型、运营商、使用的语言、WiFi信息、IP地址）以及设备状态信息（例如设备传感器数据，设备应用安装列表）。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或电话号码与您的高绩帐户相关联。
						</li>
						<li>
							日志信息：当您使用高绩平台产品和服务时，我们的服务器会自动记录一些信息，例如您对我们的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问服务的日期、时间、时长等。
						</li>
						<li>
							位置信息：当您使用具有定位功能的高绩平台产品和服务时，当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们可能会收集和处理有关您实际所在位置的信息，以使得您不需要手动输入自身地理坐标就可获得相关服务。我们会使用各种技术进行定位，这些技术包括 IP 地址、GPS 以及能够提供相关信息的其他传感器（比如可能会为我们提供附近设备、Wi-Fi 接入点和基站的信息）。您可以通过关闭定位功能，停止对您的地理位置信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
						</li>
						<li>
							唯一应用程序编号：某些产品和服务包含唯一应用程序编号，当您安装、激活、更新、卸载相关产品和服务或当这些产品和服务定期与高绩通信（例如软件的更新）时，系统会将此编号以及与安装相关的信息（例如操作系统类型和应用程序版本号）发送给高绩。
						</li>
					</ol>
					<h5>3．我们在您使用服务过程中收集的信息</h5>
					<p>当您通过我们产品或服务使用高绩关联方、合作方服务时，您同意我们根据实际业务及合作需要从我们关联方、合作方处接收、使用、汇总、分析经您授权同意其向我们提供的您的个人信息。</p>
					<p>如您通过我们产品或服务使用高绩关联方、合作方服务并进行投诉时，为便于商家能与您有效联系并及时处理您的投诉，您同意我们从合作方处获取您投诉时所提供的个人信息，并同步给对应商家。</p>

				</li>
				<li>
					<h5>3）	与您沟通</h5>
					<p>我们会利用收集的信息（例如您的手机号码、电子邮件地址）直接与您沟通或互动。例如，如果我们或我们的关联公司检测到可疑活动（例如尝试从不同于平常的位置登录您的高绩帐号）时，可能会向您发送通知。或者，我们或我们的关联公司可能与您联系，让您了解高绩及关联公司为您提供的服务即将发生的变化或改进，邀请您参加新产品的体验等。</p>
				</li>
				<li>
					<h5>4）	为您展示和推送定制内容</h5>
					<p>通过使用收集的信息，我们会得以向您提供定制内容，例如向您展现或推荐相关程度更高的搜索结果。</p>
					<p>为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告等服务。</p>
				<li>
					<h5>5）	为您提供安全保障</h5>
					<p>为提高您使用我们与关联方、合作方提供的产品和服务的安全性，我们可能使用您的信息用于身份验证、客户服务、安全防范、诈骗监测等，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或高绩关联方、合作方及社会公众的合法权益。</p>
				</li>
				<li>
					<h5>6）	改善我们的产品和服务，并开展内部审计、数据分析和研究</h5>
					<p>我们使用收集的信息来提供并改进我们及高绩关联方、合作方提供的产品和服务，并进行必要的业务运营，例如运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持等。</p>
					<p>为改进我们及高绩关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，高绩可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。</p>
					<p>我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。</p>
				</li>
				<li>
					<h5>7）	其他用途</h5>
					<p>当我们要将信息用于本隐私政策未载明的其他用途，将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
				</li>
			</ul>
		</section>
		<section>
			<h3>二、	我们如何使用Cookie 和同类技术</h3>
			<p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。</p>
			<p>当您使用高绩的产品和服务时，会向您的设备发送Cookie。当您与我们提供给合作伙伴的服务（例如广告和/或推广服务，以及可能显示在其他网站上的由高绩提供的服务功能）进行交互时，我们允许Cookie（或者其他匿名标识符）发送给高绩务器。</p>
			<p>我们不会将 Cookie 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该等修改，无法登录或使用依赖于Cookie的高绩提供的服务或功能。</p>
			<p>您可以通过更改您的浏览器设置限制高绩公司对Cookie的使用。以百度浏览器为例，您可以在百度浏览器右上方的下拉菜单的“浏览器设置”中，通过“隐私设置——清除浏览数据”，选择清除您的Cookie。</p>
		</section>
		<section>
			<h3>三、	我们如何共享、转让、公开披露您的个人信息</h3>
			<h5>1）	共享</h5>
			<p>我们会以高度的勤勉义务对待您的信息。除以下情形外，未经您同意，我们不会与除高级及其关联公司外的任何公司、组织和个人分享您的信息：</p>
			<ul>
				<li><span>1.</span>在获得您的明确同意后，我们会与其他方共享您的个人信息。我们可能会根据法律法规规定，或按政府主管部门的强制性要求或司法裁定，对外共享您的个人信息。</li>
				<li><span>2.</span>仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与提供服务相关的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</li>
			</ul>
			<p>目前，我们的授权合作伙伴包括以下类型：</p>
			<ul>
				<li>①&nbsp;服务平台或服务提供商。高绩各产品接入了丰富的第三方服务。当您选择使用该第三方服务时，您授权我们将该信息提供给第三方服务平台或服务提供商，以便其基于相关信息为您提供服务。 </li>
				<li>②&nbsp;软硬件/系统服务提供商。当第三方软硬件/系统产品或服务与高绩的产品或服务结合为您提供服务时，经您授权，我们会向第三方软硬件/系统服务提供商提供您必要的个人信息，以便您使用服务，或用于我们分析产品和服务使用情况，来提升您的使用体验。</li>
			</ul>
			<ul>
				<li><span>3.</span>为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息、保护高绩公司或其他用户或公众的人身财产安全免遭侵害或与您取得联系，您的个人信息可能会与我们的关联公司（软科等）我们只会共享必要的个人信息（如为便于您使用高绩账号使用我们关联公司产品和/或服务，我们会向关联公司共享您必要的账户信息），如果我们改变个人信息的使用及处理目的，将再次征求您的授权同意。</li>
				<li><span>4.</span>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</li>
			</ul>
			<h5>2）	转让</h5>
			<p>我们不会将您的个人信息转让给除高绩关联公司外的任何公司、组织和个人，但以下情形除外：</p>
			<ul>
				<li><span>1.</span>事先获得您的明确授权或同意；</li>
				<li><span>2.</span>满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</li>
				<li><span>3.</span>如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
			</ul>
			<h5>3）	公开批露</h5>
			<p>我们仅会在以下情形下，公开披露您的个人信息：</p>
			<ul>
				<li><span>1.</span>获得您的明确同意；</li>
				<li><span>2.</span>基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</li>
			</ul>
			<h5>4）	共享、转让、公开批露个人信息时事先征得授权同意的例外</h5>
			<p>在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
			<ul>
				<li><span>1.</span>与国家安全、国防安全直接相关的；</li>
				<li><span>2.</span>与公共安全、公共卫生、重大公共利益直接相关的；</li>
				<li><span>3.</span>与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
				<li><span>4.</span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
				<li><span>5.</span>您自行向社会公众公开的个人信息；</li>
				<li><span>6.</span>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
				<li><span>7.</span>根据个人信息主体要求签订和履行合同所必需的； </li>
				<li><span>8.</span>用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
				<li><span>9.</span>法律法规规定的其他情形。</li>
			</ul>
			<p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
		</section>
		<section>
			<h3>四、我们如何保存及保护您的个人信息</h3>
			<h5>1）	保存期限</h5>
			<p>您在使用高绩产品及服务期间，我们将持续为您保存您的个人信息。如果您注销帐户或主动删除上述信息，我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行匿名化处理后使用。</p>
			<h5>2）	保存地域</h5>
			<p>您的个人信息均储存于中华人民共和国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。</p>
			<h5>3）	安全措施</h5>
			<ul>
				<li><span>1.</span>我们会以业界成熟的安全标准和规范收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。</li>
				<li><span>2.</span>我们非常重视信息安全。我们成立了专责团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</li>
				<li><span>3.</span>我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们部署访问控制机制，对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。</li>
				<li><span>4.</span>我们提醒您注意，互联网并非绝对安全的环境，当您通过电子邮件、短信等与其他用户交互信息时，不确定第三方软件对信息的传递是否完全加密，请注意确保您个人信息的安全，我们建议您不要通过此类方式发送个人信息，以免个人信息泄露。请使用复杂密码，协助我们保证您的账号以及个人信息安全。</li>
			</ul>
			<p>根据我们的安全管理制度，个人信息泄露、毁损或丢失事件被列为最特大安全事件，一经发生将启动公司最高级别的紧急预案，由【安全部、政府关系部、法务部】等多个部门组成联合应急响应小组处理。</p>
			<h5>4）	安全事情通知</h5>
			<ul>
				<li><span>1.</span>我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。</li>
				<li><span>2.</span>个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由安全部、政府关系部、法务部等多个部门组成应急响应小组，在最短时间内追溯原因并减少损失。</li>
				<li><span>3.</span>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</li>
			</ul>
		</section>
		<section>
			<h3>五、您的权利</h3>
			<p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
			<h5>1）访问您的个人信息</h5>
			<p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
			<ul>
				<li><span>1.</span>账户信息: 如果您希望访问或编辑您的账户中的个人基本资料信息、联系方式信息、更改您的密码、添加安全信息、进行账户关联等，您可以通过产品【个人信息】执行此类操作。如果您无法通过上述方式访问该个人信息，您可以随时与我们公司进行联系。</li>
				<li><span>2.</span>其他个人信息：您在使用我们的产品和服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请可以与我们公司进行联系。</li>
			</ul>
			<h5>2）更正您的个人信息</h5>
			<p>您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以随时与我们联系。为保障安全，我们将在您行使更正权前对您的身份进行验证。</p>
			<h5>3）删除您的个人信息</h5>
			<p>在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过个人信息保护问题反馈随时与我们联系：</p>
			<ul>
				<li><span>1.</span>如果我们违法法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息。</li>
				<li><span>2.</span>如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</li>
			</ul>
			<p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
			<h5>4）改变您授权同意的范围</h5>
			<p>如您想改变授权范围，您可通过高绩平台产品的【个人信息】，例如：</p>
			<ul>
				<li><span>1.</span>您可以通过【个人信息】界面解除高绩帐号与第三方帐号的绑定关系。</li>
				<li><span>2.</span>当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</li>
			</ul>
			<h5>5）注销您的账户</h5>
			<p>您随时可注销此前注册的账户。您可以联系公司进行注销。一旦您注销高绩账号，将无法使用高绩全线用户产品和服务，因此请您谨慎操作。</p>
			<h5>6）提前获知产品和服务停止运营</h5>
			<p>高绩愿一直陪伴您，若因特殊原因导致高绩平台产品和服务被迫停止运营，我们将按照法律法规要求在产品和/或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。</p>
			<h5>7）响应您的上述请求</h5>
			<p>为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
			<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<p>
			<p>在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：</p>
			<ul>
				<li><span>1.</span>与国家安全、国防安全直接相关的。</li>
				<li><span>2.</span>与公共安全、公共卫生、重大公共利益直接相关的。</li>
				<li><span>3.</span>与犯罪侦查、起诉、审判和执行判决等直接相关的。</li>
				<li><span>4.</span>我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）。</li>
				<li><span>5.</span>响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的。</li>
				<li><span>6.</span>涉及商业秘密的。</li>
			</ul>
		</section>
		<section>
			<h3>六、我们如何处理未成年人的个人信息</h3>
			<p>高绩非常重视对未成年人信息的保护。</p>
			<p>我们的产品、网站和服务主要面向成人。若您是未成年人，建议您请您的监护人仔细阅读本隐私政策，并在征得您的监护人同意的前提下使用我们的产品和/或服务或向我们提供信息。</p>
			<p>如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。</p>
			<p>如果监护人发现我们在未获监护人同意的情况下收集了未成年人的个人信息，请通过个人信息保护问题反馈联系我们，我们会设法尽快删除相关数据。</p>
		</section>
		<section>
			<h3>七、您的个人信息如何进行跨境转移</h3>
			<p>原则上，我们在中国境内收集和产生的个人信息，将存储在中国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。</p>
		</section>
		<section>
			<h3>八、本隐私政策如何更新</h3>
			<p>我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。我们会在本页面上发布对本隐私政策所做的任何变更。</p>
			<p>若您不同意该等变更可以停止使用高绩平台产品和服务，若您继续使用我们的产品和/或服务，即表示您同意受修订后的本隐私政策的约束。</p>
			<p>本隐私政策所指的重大变更包括但不限于：</p>
			<ul>
				<li><span>1.</span>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。</li>
				<li><span>2.</span>个人信息共享、转让或公开披露的主要对象发生变化。</li>
				<li><span>3.</span>您参与个人信息处理方面的权利及其行使方式发生重大变化。</li>
				<li><span>4.</span>其他可能对您的个人信息权益产生重大影响的变化时。</li>
			</ul>
		</section>
		<section>
			<h3>九、如何联系我们</h3>
			<p>如您对本隐私政策有任何意见或建议，可通过直接联系我们。</p>
			<p>为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在【30】天内回复。</p>
			<p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求结局方案：向【高绩住所地有管辖权的法院提起诉讼】。</p>
		</section>
		<section>
			<h3>附录1：定义</h3>
			<h5>本隐私政策中使用的特定词语，具有如下含义：</h5>
			<ul>
				<li><span>1.</span>“我们”或“高绩”，指上海高绩数据科技有限公司。</li>
				<li><span>2.</span>“您”，指使用我们的产品和服务的注册用户以及收费服务的购买方。</li>
				<li><span>3.</span>“高绩平台”，指高绩网站及高绩客户端。</li>
				<li><span>4.</span>“高绩关联方、合作方”，指我们的关联公司、投资公司、联盟成员、合作伙伴及其他受信任的第三方供应商、服务商及代理商。</li>
				<li><span>5.</span>“我们的产品和服务”或“高绩平台产品和服务”，指高绩旗下各专门频道或平台服务（包括但不限于学科发展水平数据监测平台、大学360度数据监测平台、高校状态指标数据库等）。</li>
				<li><span>6.</span>“个人信息”，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、网络身份标识信息、个人教育工作信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。</li>
				<li><span>7.</span>“个人信息主体”，指个人信息所标识的自然人。</li>
				<li><span>8.</span>“个人敏感信息”，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人身份信息、网络身份标识信息等。</li>
				<li><span>9.</span>“去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</li>
				<li><span>10.</span>“匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</li>
				<li><span>11.</span>“中国”或“中国境内”，指中华人民共和国大陆地区，仅为本隐私政策之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。</li>
			</ul>	
		</section>
  </div>
</template>

<script>
import { getUserInfo, updateUserInfo } from "@/api/profile";
import {
  sendSmsAuthCode,
  addMobileCheck,
  saveMobile,
  removeMobile,
} from "@/api/login";
export default {
  name: "privacy_policy",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scope>
.privacy-policy {
  text-align: left;
  font-size: 14px;
  color: #343438;
	word-break: break-all;
	section{
    font-size: 14px;
    line-height: 22px;
    color: #343438;
		margin-bottom: 54px;
		h2 {
			height: 32px;
			line-height: 32px;
			margin: 9px 0;
			font-size: 20px;
			color: #434345;
			margin-bottom: 8px;
		}
		h3{
			font-size: 16px;
			height: 16px;
			line-height: 16px;
			margin-bottom: 18px;
		}
		h5{
			font-size: 14px;
			font-weight: 600;
			margin-bottom: 14px;
		}
		p{
			margin-bottom: 14px;
		}
		div{
			margin-bottom: 14px;
		}
		li{
			margin-bottom: 14px;
			span{
				display: inline-block;
				margin-right: 8px;
			}
		}
	}
}
</style>
